import httpClient from "../http/http-client";
import { IPostVehicle, IVehicleDetails } from './vehicle.model';

export default class VehicleService {
  http;
  vehicles?: IVehicleDetails[];
  activeVehicles?: IVehicleDetails[];
  static instance = new VehicleService();

  static getInstance() {
    if (VehicleService.instance === null) VehicleService.instance = new VehicleService();
    return this.instance;
  }


  constructor() {
    this.http = httpClient
  }

  async getAllVehicles(forceUpdate: boolean = false): Promise<IVehicleDetails[]> {
    if (this.vehicles && !forceUpdate) {
      return Promise.resolve(this.vehicles);
    } else {
      return this.http.get('vehicle')
        .then(response => {
          this.vehicles = response.data.rows;
          this.activeVehicles = response.data.rows.filter((vehicle: IVehicleDetails) => vehicle.active)
          return response.data.rows
        })
        .catch(err => {
          console.log(err)
          throw err;
        });
    }
  }

  async getAllActiveVehicles(forceUpdate: boolean = false): Promise<IVehicleDetails[]> {
    if (this.vehicles && !forceUpdate) {
      return Promise.resolve(this.vehicles);
    } else {
      return this.http.get('vehicle')
        .then(response => {
          this.vehicles = response.data.rows;
          this.activeVehicles = response.data.rows.filter((vehicle: IVehicleDetails) => vehicle.active)
          return response.data.rows.filter((vehicle: IVehicleDetails) => vehicle.active)
        })
        .catch(err => {
          console.log(err)
          throw err;
        });
    }
  }

  async getAllVehiclesWithPagination(active: boolean, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IVehicleDetails[] }> {
    return this.http.get(`vehicle?active=${active}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async create(vehicle: IPostVehicle): Promise<IPostVehicle> {
    return this.http.post('vehicle', vehicle)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOneVehicle(id: string): Promise<IVehicleDetails> {
    return this.http.get(`vehicle/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async editVehicle(id: string, newVehicle: IPostVehicle): Promise<IPostVehicle> {
    return this.http.patch(`vehicle/${id}`, newVehicle)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async deactivate(vehicleId: string): Promise<IVehicleDetails> {
    return this.http.patch(`vehicle/${vehicleId}/deactivate`, { vehicleId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async remove(vehicleId: string): Promise<IVehicleDetails> {
    return this.http.delete(`vehicle/${vehicleId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  clearData() {
    this.vehicles = undefined;
    this.activeVehicles = undefined;
  }
}